import { Icons } from 'src/common/components'

import styles from './modal.module.scss'
import { EnumModalType } from './types'

export const MODAL_ICON = {
  Check: <Icons.Check className={styles['svg-md']} />,
  Warning: <Icons.Warning className={styles['svg-xl']} />,
  Trash: <Icons.Trash className={styles['svg-md']} />,
}

export const MODAL_COLOR = {
  [EnumModalType.SUCCESS]: 'var(--mantine-color-blue-7)',
  [EnumModalType.WARNING]: 'var(--mantine-color-orange-4)',
  [EnumModalType.ERROR]: 'var(--mantine-color-red-6)',
}
